import * as React from 'react';

export interface IEmptyResultsProps {
}

export class EmptyResults extends React.Component<IEmptyResultsProps, any> {

    render() {

      return (
        <div className="search-app-results-messaging">
          <div className="empty-results-message" dangerouslySetInnerHTML={{ __html: "<h5>Please enter a search query in the searchbar above to find resources on the AAPD website.</h5>" }} />
        </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/search-page/components/search-results/empty.tsx